import React from "react";

import { Navigate, Outlet } from "react-router-dom";
//KS: 2023-07-19 footerSectionFilteredFlag (Add)
const ProtectedRoute = ({ submenuFiltered, footerSectionFilteredFlag }) => {
  return (submenuFiltered.length > 0 || footerSectionFilteredFlag > 0) ? <Outlet /> : <Navigate to="/home" />;
};

export default ProtectedRoute;
